import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useConfig } from "../hooks";
import { PageLoading } from "../shared";
import { isFeatureEnabledFromConfig } from "../utils/featureFlags";

/**
 * Client-side feature guard.
 *
 * - Reads resolved tenant feature flags from `configs.featureFlags`.
 * - GA flags default to enabled when missing; beta flags use opt-in (`=== true`).
 * - Set `optIn` to force opt-in semantics for a specific route.
 * - Set `hideForAppTypes` to redirect tenants whose app type should not use the route.
 */
const RequireFeature = ({
  featureKey,
  children,
  fallbackPath = "/",
  optIn = false,
  hideForAppTypes,
}) => {
  const location = useLocation();
  const { configs, loading, appType } = useConfig();

  if (loading) {
    return <PageLoading />;
  }

  if (
    Array.isArray(hideForAppTypes) &&
    hideForAppTypes.length > 0 &&
    hideForAppTypes.includes(appType)
  ) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  if (!featureKey) {
    return children;
  }

  const enabled = isFeatureEnabledFromConfig(configs, featureKey, { optIn });

  if (!enabled) {
    return <Navigate to={fallbackPath} replace state={{ from: location }} />;
  }

  return children;
};

export default RequireFeature;

